<!--
 * @Description: 批改作业管理 列表页
 * @Author: PF
 * @Date: 2022-09-23 11:53:25
 * @LastEditors: PF
 * @LastEditTime: 2024-08-02 11:52:20
-->
<template>
  <div>
    <el-dialog class="wp80 hp80" :model-value="openDetail" :close-on-click-modal="false" :show-close="false" destroy-on-close>
      <template #header>
        <div class="header-left">
          <span class="header-title">{{title}}</span>
        </div>
        <div class="header-right">
          <el-button type="info" text @click="closeWindow('openDetail', emits, false)">
            <el-icon>
              <Close />
            </el-icon>
          </el-button>
        </div>
      </template>
    <el-container>
      <el-main class="pl0 pr0">
        <el-table :data="dataGrid.data" :default-sort="dataGrid.orderBy" v-loading="dataGrid.loading" @sort-change="dataGrid.sortChange" height="100%" border stripe>
          <!-- 冻结列-Left BEGIN -->
          <el-table-column label="序号" type="index" width="80" fixed align="center" />
          <el-table-column label="学号" prop="xsxh" fixed align="center" show-overflow-tooltip sortable :sort-orders="['ascending', 'descending']"/>
          <el-table-column label="学生" prop="xsxm" fixed align="center" show-overflow-tooltip sortable :sort-orders="['ascending', 'descending']"/>
          <!-- 冻结列-Left END -->
          <el-table-column label="提交时间" prop="tjsj" width="140" align="center" show-overflow-tooltip sortable :sort-orders="['ascending', 'descending']"/>
          <el-table-column label="分数" prop="zdf" width="140" align="center" show-overflow-tooltip sortable :sort-orders="['ascending', 'descending']"/>
          <el-table-column label="状态" prop="zt" align="center" show-overflow-tooltip sortable :sort-orders="['ascending', 'descending']">
            <template #default="scope">
              <span v-for="(item, index) in xszyztData.list" :key="index">
                <span v-if="scope.row.zt === item.value">{{item.name}}</span>
              </span>
            </template>
          </el-table-column>
          <el-table-column label="作业类型" width="110" prop="zylx" align="center" show-overflow-tooltip sortable :sort-orders="['ascending', 'descending']">
            <template #default="scope">
              <span v-for="(item, index) in xszylxData.list" :key="index">
                <span v-if="scope.row.zylx === item.value">{{item.name}}</span>
              </span>
            </template>
          </el-table-column>
          <!-- 冻结列-Right BEGIN -->
          <el-table-column label="操作" width="120" fixed="right" align="center">
            <template #default="scope">
              <el-button v-if="scope.row.zylx === xszylxData.xianShangZuoYe" link type="success" @click="openXianShangZuoYeXiangQing=true;row=scope.row">详情</el-button>
              <el-button v-if="scope.row.zylx === xszylxData.xianXiaZuoYe" link type="success" @click="openXianXiaZuoYeXiangQing=true; row=scope.row">详情</el-button>
            </template>
          </el-table-column>
          <!-- 冻结列-Right END -->
        </el-table>
      </el-main>
    </el-container>
      <template #footer>
        <div class="dialog-footer">
        <pagination :pagination="dataGrid.pagination" @ReturnData="bindTable" />
          <div class="footer_but">
            <el-button type="info" @click="closeWindow('openDetail', emits, false)">关闭</el-button>
          </div>
        </div>
      </template>
    </el-dialog>
  </div>
  <xianshangzuoyexiangqing v-if="openXianShangZuoYeXiangQing" v-model:openXianShangZuoYe="openXianShangZuoYeXiangQing" :row="row" @ReturnData="bindTable" />
  <xianxiazuoyexiangqing v-if="openXianXiaZuoYeXiangQing" v-model:openXianXiaZuoYe="openXianXiaZuoYeXiangQing" :row="row" @ReturnData="bindTable" />
</template>

<script setup>
import { ref, watch, defineProps, defineEmits } from 'vue'
import { loadList, loadSelect, closeWindow } from '@/api/common.js'
import { getZuoYeLeiXing } from '@/utils/meiju'
import pagination from '@/components/pagination.vue'
import xianshangzuoyexiangqing from '@/components/home/changguishiwu/jiaoshi/pigaizuoye/xianshangzuoyexiangqing.vue'
import xianxiazuoyexiangqing from '@/components/home/changguishiwu/jiaoshi/pigaizuoye/xianxiazuoyexiangqing.vue'

const props = defineProps({ openDetail: { type: Boolean, required: true }, row: { type: Object, required: false } })
const emits = defineEmits(['update:openDetail', 'ReturnData'])
const title = ref()
const dataGrid = ref({
  parms: {},
  data: [],
  pagination: {},
  loading: false,
  orderBy: { prop: 'xsxh', order: 'ascending' }, // ['ascending', 'descending']
  sortChange: function (column) {
    dataGrid.value.orderBy.prop = column.prop
    dataGrid.value.orderBy.order = column.order
    bindTable()
  }
})
const bindTable = async (pageNo, pageSize) => {
  loadList({
    url: '/api/v2/ziyuanku/xueshengzuoye/banjixueshengzuoye',
    pageNo: pageNo || 1,
    pageSize: pageSize || 100,
    pagerCount: 5,
    dataGrid: dataGrid.value
  })
}
const xszyztData = ref({ list: [] })
const xszylxData = ref({ list: [] })

// 弹窗
const row = ref()
const openXianShangZuoYeXiangQing = ref(false)
const openXianXiaZuoYeXiangQing = ref(false)

watch(
  () => props.openDetail,
  () => {
    if (props.openDetail) {
      title.value = props.row.title
      dataGrid.value.parms.bjzyid = props.row.id

      loadSelect({
        url: '/api/v2/ziyuanku/xueshengzuoye/xueshengzuoyezhuangtai',
        data: xszyztData
      })
      xszylxData.value = getZuoYeLeiXing()
      bindTable()
    }
  },
  { deep: true, immediate: true }
)
</script>
